import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Dropdown } from 'bootstrap';
import { Observable } from 'rxjs/internal/Observable';

import { PermissionService } from '../../../../../core/services/permission.service';
import { environment } from '../../../../../environments/environment';
import { WarehouseModel } from '../../../../../modules/warehouse-management/features/warehouses/models/warehouse.models';
import { WarehouseService } from '../../../../../modules/warehouse-management/features/warehouses/services/warehouse-api.service';
import { Apps, Status } from '../../../../enums/enum';
import { LoginModel } from '../../../../models/baseUser.model';
import { MenuItem } from '../../../../models/menuItems.model';
import { BreadcrumbService } from '../../../../services/breadcrumb.service';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { MasterService } from '../../../../services/master.service';
import { SharedUserApiService } from '../../../../services/shared-user-api.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-navigation-web',
  standalone: false,
  templateUrl: './navigation-web.component.html',
  styleUrl: './navigation-web.component.css'
})
export class NavigationWebComponent {
  @ViewChild('selectOutlet') selectOutlet!: ElementRef<HTMLElement>;
  @ViewChild('menuWrapper', { static: true }) menuWrapper!: ElementRef;

  breadcrumbs$!: Observable<string[]>;
  userInfo: LoginModel = new LoginModel();
  isDropdownOpen: boolean = false;
  isTablet = window.innerWidth <= 768;
  selectedMenu: string | null = null;
  activeModule: string | null = null;
  currentRoute: string = '';
  companyUrl: string = environment.companyUrl;
  userPermissions: string[] = [];
  filteredMenuItems: MenuItem[] = [];
  roles: string[] = [];
  isEnableOnlyWms: boolean = false;
  listerUrl: string = environment.listerUrl;
  tpmUrl: string = environment.tpmUrl;
  posUrl: string = environment.posUrl;
  donationUrl: string = environment.donationUrl;
  consignmentUrl: string = environment.consignmentUrl;
  selectedWarehouseId: number = 0;
  selectedWarehouseName: string = '';
  warehouses: WarehouseModel[] = [];
  isDefault: boolean = true;
  isWorkActive: boolean = true;
  menuItems: MenuItem[] = [
    {
      title: 'Dashboard',
      route: '/dashboard',
      active: true,
      activeIcon: 'assets/images/icons/dashboard-active.svg',
      inactiveIcon: 'assets/images/icons/dashboard-inactive.svg',
      requiresAnyPermission: true
      // requiredPermissions: ['Dashboard:View'],
    },
    {
      title: 'Inquiry',
      route: '/inquiries',
      active: false,
      activeIcon: 'assets/images/icons/enquiry-active.svg',
      inactiveIcon: 'assets/images/icons/enquiry-inactive.svg',
      requiresAnyPermission: true,
      requiredPermissions: ['Inquiry:ItemInquiry', 'Inquiry:LicensePlateInquiry', 'Inquiry:LocationInquiry']
    },
    {
      title: 'Work',
      route: '/work-items',
      active: false,
      activeIcon: 'assets/images/icons/work-active.svg',
      inactiveIcon: 'assets/images/icons/work-inactive.svg',
      requiresAnyPermission: true,
      requiredPermissions: ['Worklist:View']
    },
    {
      title: 'Worklist',
      route: '/worklists',
      active: false,
      activeIcon: 'assets/images/icons/worklist-active.svg',
      inactiveIcon: 'assets/images/icons/worklist-inactive.svg',
      requiresAnyPermission: true,
      requiredPermissions: ['Worklist:View']
    },
    {
      title: 'Inventory',
      route: '/inventory',
      active: false,
      activeIcon: 'assets/images/icons/inventory-active.svg',
      inactiveIcon: 'assets/images/icons/inventory-inactive.svg',
      requiresAnyPermission: true,
      requiredPermissions: [
        'LicensePlate:View',
        'StockAdjustment:View',
        'MovementOrder:View',
        'TransferOrder:View',
        'InventoryCount:View'
      ],
      children: [
        {
          title: 'License Plates',
          route: 'inventory/license-plate',
          active: false,
          requiredPermissions: ['LicensePlate:View']
        },
        {
          title: 'Stock Adjustments',
          route: 'inventory/stock-adjustment',
          active: false,
          requiredPermissions: ['StockAdjustment:View']
        },
        {
          title: 'Movement Orders',
          route: 'movement-orders/movements-listing',
          active: false,
          requiredPermissions: ['MovementOrder:View']
        },
        {
          title: 'Transfer Orders',
          route: 'transfer-orders/transfer-orders-listing',
          routes: ['transfer/transfer-receive-orders-listing'],
          active: false,
          requiredPermissions: ['TransferOrder:View']
        },
        {
          title: 'Inventory Counts',
          route: 'counting/counting/inventory-count-listing',
          active: false,
          requiredPermissions: ['InventoryCount:View']
        },
        {
          title: 'Sales Orders',
          route: 'sales-orders',
          active: false
          // requiredPermissions: ['SalesOrder:View'],
        }
      ]
    },
    {
      title: 'Warehouse',
      active: false,
      activeIcon: 'assets/images/icons/warehouse-active.svg',
      inactiveIcon: 'assets/images/icons/warehouse-inactive.svg',
      requiresAnyPermission: true,
      requiredPermissions: [
        'LocationType:View',
        'LocationFormat:View',
        'StorageUnit:View',
        'LocationProfile:View',
        'Warehouse:View',
        'ZoneType:View',
        'Zone:View',
        'Location:View'
      ],
      children: [
        {
          title: 'Location Formats',
          route: '/warehouse-management/location-formats',
          active: false,
          requiredPermissions: ['LocationFormat:View']
        },
        {
          title: 'Location Profiles',
          route: '/warehouse-management/location-profiles',
          active: false,
          requiredPermissions: ['LocationProfile:View']
        },
        {
          title: 'Location Types',
          route: '/warehouse-management/location-types',
          active: false,
          requiredPermissions: ['LocationType:View']
        },
        {
          title: 'Locations',
          route: '/warehouse-management/locations',
          active: false,
          requiredPermissions: ['Location:View']
        },
        {
          title: 'Package Types',
          route: '/warehouse-management/shipment-boxes',
          active: false,
          requiredPermissions: ['PackageType:View']
        },
        {
          title: 'Storage Units',
          route: '/warehouse-management/storage-units',
          active: false,
          requiredPermissions: ['StorageUnit:View']
        },
        {
          title: 'Warehouses',
          route: '/warehouse-management/warehouses',
          active: false,
          requiredPermissions: ['Warehouse:View']
        },
        {
          title: 'Zone Types',
          route: '/warehouse-management/zone-types',
          active: false,
          requiredPermissions: ['ZoneType:View']
        },
        {
          title: 'Zones',
          route: '/warehouse-management/zones',
          active: false,
          requiredPermissions: ['Zone:View']
        }
      ]
    },
    {
      title: 'Carriers',
      route: '/carriers',
      active: false,
      activeIcon: 'assets/images/icons/carriers_active.svg',
      inactiveIcon: 'assets/images/icons/carriers_inactive.svg',
      requiredPermissions: ['Carrier:View']
    }
    // {
    //   title: 'New Goods Labelling',
    //   route: '/new-goods-labelling',
    //   active: false,
    //   activeIcon: 'assets/images/icons/new_goods_labelling_active.svg',
    //   inactiveIcon: 'assets/images/icons/new_goods_labelling_inactive.svg',
    //   requiredPermissions: ['GoodsLabel:View'],
    // },
  ];

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private masterService: MasterService,
    private userService: UserService,
    private sharedUserApiService: SharedUserApiService,
    private permissionService: PermissionService,
    private warehouseService: WarehouseService,
    private errorHandlerService: ErrorHandlerService
  ) {
    this.router = router;
    window.addEventListener('resize', () => {
      this.isTablet = window.innerWidth <= 768;
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const parent = this.menuItems.find(m => this.isMenuActiveByRoute(m));
        if (parent) {
          this.activeModule = parent.title;
        }
        this.selectedMenu = parent?.children?.length ? parent.title : null;
      }
    });
  }

  async ngOnInit() {
    await this.permissionService.ensurePermissionsLoaded(Apps.IMS);
    this.roles = this.permissionService.getAllRoles();
    this.isEnableOnlyWms = environment.enableOnlyWms;

    if (this.userService.isAuthenticated()) {
      this.userInfo = this.masterService.getUserDetailFromStorage();

      // Read persisted preference for "Save My Preference" from localStorage
      const storedPref = localStorage.getItem('imsSavePreference');
      if (storedPref !== null) {
        this.isDefault = storedPref === 'true';
      }
      // If user does not want to save as default, restore last selected from localStorage
      if (!this.isDefault) {
        const storedSelected = localStorage.getItem('imsSelectedWarehouseId');
        if (storedSelected) {
          this.selectedWarehouseId = Number(storedSelected);
          this.syncSessionWarehouse(this.selectedWarehouseId);
        } else {
          this.selectedWarehouseId = this.userInfo.imsDefaultWarehouseId;
        }
      } else {
        // Use default from user profile
        this.selectedWarehouseId = this.userInfo.imsDefaultWarehouseId;
      }

      if (this.selectedWarehouseId === 0 || this.selectedWarehouseId === null) {
        setTimeout(() => {
          this.selectOutlet.nativeElement.click();
        }, 0);
      }
    }

    if (window.innerWidth <= 768) {
      location.reload();
    }
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;

    this.userPermissions = this.permissionService.getAllPermissions();
    this.filterMenuItems();
    this.getWarehouses();
  }

  ngAfterViewInit() {
    const dropdownElement = document.getElementById('dropdownMenuButton22');
    if (dropdownElement) {
      new Dropdown(dropdownElement);
    }
  }

  toggleDefaultPreferrence() {
    this.isDefault = !this.isDefault;
    localStorage.setItem('imsSavePreference', String(this.isDefault));
  }

  filterMenuItems(): void {
    const baseMenuItems = [...this.menuItems];
    const wmsFilteredItems = this.filterMenuItemsByWms(baseMenuItems);
    this.menuItems = this.filterMenuItemsByPermissions(wmsFilteredItems);
  }

  private filterMenuItemsByWms(menuItems: MenuItem[]): MenuItem[] {
    if (!this.isEnableOnlyWms) {
      return menuItems;
    }

    const allowedMenuTitles = ['Warehouse', 'Dashboard', 'Inquiry', 'Inventory', 'Carriers', 'Worklist', 'Work'];

    menuItems.filter(menu => allowedMenuTitles.includes(menu.title));

    if (this.isEnableOnlyWms) {
      menuItems.forEach(ele => {
        if (ele.title == 'Inventory') {
          ele.children = ele.children?.filter(child => child.title != 'Stock Adjustments');
        }
      });
    }

    return menuItems;
  }

  private filterMenuItemsByPermissions(menuItems: MenuItem[]): MenuItem[] {
    return menuItems.filter(menu => {
      if (!menu.requiredPermissions || menu.requiredPermissions.length === 0) {
        if (menu.children) {
          menu.children = this.filterMenuItemsByPermissions(menu.children);
          return menu.children.length > 0;
        }
        return true;
      }

      const hasPermission = menu.requiresAnyPermission
        ? menu.requiredPermissions.some(permission => this.userPermissions.includes(permission))
        : menu.requiredPermissions.every(permission => this.userPermissions.includes(permission));

      if (hasPermission && menu.children) {
        menu.children = this.filterMenuItemsByPermissions(menu.children);
        return menu.children.length > 0;
      }

      return hasPermission;
    });
  }

  private revertActiveModuleToCurrentRoute(): void {
    const parent = this.menuItems.find(m => this.isMenuActiveByRoute(m));
    if (parent) this.activeModule = parent.title;
  }

  onMenuClick(menu: MenuItem, event?: MouseEvent): void {
    event?.stopPropagation();

    if (menu.children && menu.children.length > 0) {
      if (this.selectedMenu === menu.title) {
        this.selectedMenu = null;
        this.revertActiveModuleToCurrentRoute();
      } else {
        this.selectedMenu = this.activeModule = menu.title;

        if (!this.isMenuActiveByRoute(menu)) {
          const route = menu.children[0].route ?? menu.children[0].routes?.[0];
          if (route) this.router.navigate([route]);
        }
      }
    } else if (menu.route) {
      this.selectedMenu = null;
      this.activeModule = menu.title;
      this.router.navigate([menu.route]);
    } else if (menu.routes && menu.routes.length > 0) {
      this.selectedMenu = null;
      this.activeModule = menu.title;
      this.router.navigate([menu.routes[0]]);
    }

    this.menuItems.forEach(m => {
      m.active = m.title === this.activeModule;
    });
  }

  isMenuActive(menu: MenuItem): boolean {
    return this.activeModule === menu.title;
  }

  private isMenuActiveByRoute(menu: MenuItem): boolean {
    const currentUrl = this.router.url.split('?')[0];

    if (menu.children?.length) {
      const childMatch = menu.children.some(child => {
        if (child.route) {
          const childRoute = child.route.startsWith('/') ? child.route : '/' + child.route;
          if (currentUrl === childRoute || currentUrl.startsWith(childRoute + '/')) return true;
        }
        if (child.routes?.length) {
          return child.routes.some(r => {
            const childRoute = r.startsWith('/') ? r : '/' + r;
            return currentUrl === childRoute || currentUrl.startsWith(childRoute + '/');
          });
        }
        return false;
      });

      if (childMatch) return true;
    }

    if (menu.routes?.length) {
      const multiMatch = menu.routes.some(r => {
        const route = r.startsWith('/') ? r : '/' + r;
        return currentUrl === route || currentUrl.startsWith(route + '/');
      });

      if (multiMatch) return true;
    }

    if (menu.route) {
      const route = menu.route.startsWith('/') ? menu.route : '/' + menu.route;
      return currentUrl === route || currentUrl.startsWith(route + '/');
    }

    return false;
  }

  getWarehouses() {
    const queryParams: Record<string, any> = {
      CompanyId: this.userInfo.companyId,
      Status: Status.Active
    };
    this.warehouseService.getAllWarehouses(queryParams).subscribe(
      response => {
        this.warehouses = response as WarehouseModel[];
        this.selectedWarehouseName = this.warehouses.find(item => item.id === this.selectedWarehouseId)?.name ?? '';
      },
      error => {
        this.errorHandlerService.handleApiError(error);
      }
    );
  }

  SaveWarehouse() {
    // Persist the current preference selection
    localStorage.setItem('imsSavePreference', String(this.isDefault));
    // Persist current selection for non-default sessions as well
    localStorage.setItem('imsSelectedWarehouseId', String(this.selectedWarehouseId));

    if (this.isDefault) {
      // Step: Save preference via API
      this.sharedUserApiService
        .setDefaultWarehouse(this.userInfo.userId, this.selectedWarehouseId, Apps.IMS, this.isDefault)
        .subscribe(
          result => {
            this.updateLocalStorageUserAndReload();
          },
          error => {
            this.errorHandlerService.handleApiError(error);
          }
        );
    } else {
      // Step: Switch warehouse for only this session (skip API call)
      this.updateLocalStorageUserAndReload();
    }
  }

  private updateLocalStorageUserAndReload() {
    this.syncSessionWarehouse(this.selectedWarehouseId);

    // If saving as default, also update the permanent user object in localStorage
    if (this.isDefault) {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          const loggedInUser = JSON.parse(userStr);
          loggedInUser.imsDefaultWarehouseId = this.selectedWarehouseId;
          localStorage.setItem('user', JSON.stringify(loggedInUser));
        } catch (e) {
          console.error('Error updating permanent user storage:', e);
        }
      }
    }

    this.selectedWarehouseName = this.warehouses.find(item => item.id === this.selectedWarehouseId)?.name ?? '';

    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
      window.location.reload();
    });
  }

  private syncSessionWarehouse(warehouseId: number) {
    this.userInfo.imsDefaultWarehouseId = warehouseId;
  }

  getSubmenu(title: string): MenuItem[] {
    const selected = this.menuItems.find(menu => menu.title === title);
    return selected?.children ?? [];
  }

  hasPermission(permission: string): boolean {
    return this.userPermissions.includes(permission);
  }

  closeSubmenu(): void {
    this.selectedMenu = null;
    this.revertActiveModuleToCurrentRoute();
  }

  handleDropdownToggle() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    this.showContextMenu = false;
    if (this.selectedMenu && this.menuWrapper && !this.menuWrapper.nativeElement.contains(event.target as Node)) {
      this.selectedMenu = null;
      this.revertActiveModuleToCurrentRoute();
    }
  }

  logout(): void {
    this.isDropdownOpen = false;
    this.userService.logout();
  }

  redirectToModule(appId: number) {
    switch (appId) {
      case Apps.TPMPortal:
        const baseUrl = this.tpmUrl.split('?')[0];
        this.tpmUrl = `${baseUrl}?appId=${appId}`;
        window.location.href = this.tpmUrl; // ✅ External redirect
        break;
      case Apps.POS:
        window.location.href = this.posUrl; // ✅ External redirect
        break;
      case Apps.Lister:
        window.location.href = this.listerUrl; // ✅ External redirect
        break;
      case Apps.Donation:
        window.location.href = this.donationUrl; // ✅ External redirect
        break;
      case Apps.Consignment:
        window.location.href = this.consignmentUrl; // ✅ External redirect
        break;
      case Apps.CompanyPortal:
        window.location.href = this.companyUrl; // ✅ External redirect
        break;
      default:
        console.error('Invalid module name');
        return;
    }
  }

  contextMenuPosition = { x: '0px', y: '0px' };
  showContextMenu = false;
  selectedApp: any = null;
  onRightClick(event: MouseEvent, item: any) {
    event.preventDefault(); // prevent default browser menu
    this.selectedApp = item;

    this.contextMenuPosition.x = `${event.clientX}px`;
    this.contextMenuPosition.y = `${event.clientY}px`;
    this.showContextMenu = true;
  }

  openInNewTab() {
    this.showContextMenu = false;
    if (this.selectedApp) {
      const appId = this.selectedApp;
      const url = this.getAppUrl(appId); // generate the URL
      window.open(url, '_blank'); // ✅ open in new tab
    }
  }

  // Create a method to build the correct URL
  getAppUrl(appId: number): string {
    switch (appId) {
      case Apps.TPMPortal:
        const baseUrl = this.tpmUrl.split('?')[0];
        return `${baseUrl}?appId=${appId}`;
      case Apps.POS:
        return this.posUrl;
      case Apps.Lister:
        return this.listerUrl;
      case Apps.Donation:
        return this.donationUrl;
      case Apps.Consignment:
        return this.consignmentUrl;
      case Apps.CompanyPortal:
        return this.companyUrl;
      default:
        return '';
    }
  }
}
